import { render } from "./case.vue?vue&type=template&id=4bff7134"
import script from "./case.vue?vue&type=script&lang=js"
export * from "./case.vue?vue&type=script&lang=js"

import "./case.vue?vue&type=style&index=0&id=4bff7134&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__